import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { FC, forwardRef, useEffect, useRef } from "react";
import { TextField } from "@mui/material";
import toast from "react-hot-toast";
import FileUpload from "../../../components/FileUpload";
import useFileUploadHandler from "../../../useFilesHandler";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type AddRemarksModalProps = {
  openModal: boolean;
  handleCloseModal: () => void;
};
const AddRemarksModal: FC<AddRemarksModalProps> = ({
  openModal,
  handleCloseModal,
}): JSX.Element => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileUploadHandler = useFileUploadHandler({
    fileuploadFinallyCallback: () => {
      if (fileInputRef?.current) {
        fileInputRef.current.value = "";
      }
    },
  });
  useEffect(() => {
    if (!openModal) {
      fileUploadHandler.clearAllFiles();
    }
  }, [openModal]);
  return (
    <Dialog
      fullScreen
      open={openModal}
      onClose={handleCloseModal}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography sx={{ ml: 4, flex: 1 }} variant="h6" component="div">
            Add Remarks in your Objection request
          </Typography>
          <div className="flex items-center justify-end">
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseModal}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <div className="h-full md:w-[80%] w-full flex flex-col mx-auto  md:mt-10 ">
        <p className="ml-1 my-1 mt-8 text-muted-background">Remarks</p>
        <textarea
          autoFocus
          className="w-full h-[160px] border border-gray-300 rounded-md p-3 focus:border-blue-300 outline-none"
        />
        <p className="ml-1 my-1 mt-7 text-muted-background">
          Upload Suporting Document
        </p>
        <FileUpload
          inputRef={fileUploadHandler.multiFormFileRef}
          selectedFiles={fileUploadHandler.images}
          isRequired
          fileUploadEvent={(files: any | Array<any>) => {
            const file: any = files?.[0];
            
            if (file.type === "application/pdf") {
              // setUploadFile(files?.[0]);
              fileUploadHandler.FileUploadSuccessHandler(file);
            } else {
              toast.error("Please upload a valid .pdf file");
            }
          }}
          label={"Upload File"}
        />
        <div className="mt-10 flex items-center justify-end">
          <Button variant="contained">Submit</Button>
        </div>
      </div>
    </Dialog>
  );
};

export default AddRemarksModal;
